import styles from "./NextRoomButton.module.scss";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";

import ArrowUpIcon from "@Icons/ArrowUpIcon";
import CrossIcon from "@Icons/CrossIcon";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import gtagEventEmitter from "helpers/gtagEventEmitter";

const NextRoomButton = () => {
  const { showNextRoomButton, nextRoomId } = useSelector(
    ({ propertyPageData }: AppState) => ({
      showNextRoomButton: propertyPageData.showNextRoomButton,
      nextRoomId: propertyPageData.nextRoomId,
    }),
    shallowEqual,
  );
  const onNextRoomButtonClick = () => {
    gtagEventEmitter({
      action: "go_to_next_room_clicked",
      category: "Room Type Section",
    });
    document
      .getElementById(nextRoomId)
      ?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  };

  const dispatch = useDispatch();
  const propertyPageDispatcher = new PropertyPageDispatcher(dispatch);
  return (
    <>
      {showNextRoomButton && nextRoomId && (
        <div className={styles.moreTenanciesPill}>
          <button type="button" onClick={onNextRoomButtonClick}>
            <ArrowUpIcon />
            Go To Next Room
            <span
              onClick={(e) => {
                e.stopPropagation();
                gtagEventEmitter({
                  action: "go_to_next_room_crossed",
                  category: "Room Type Section",
                });
                propertyPageDispatcher.showNextRoomButton({ state: false, id: "" });
              }}
              role="none"
            >
              <CrossIcon />
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default wrapperHOC(NextRoomButton, {
  componentName: "LeftSectionDesktop-NextRoomButton",
  showForChina: true,
});
